import { getANMS, getBidderEmail, getBidderId, getUserFullName, isProfileComplete } from '@/redux/modules/user';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getIsBidderCardValid } from '@/redux/modules/bidderCardStatus';
import { getUseFullstory } from '@/redux/modules/config';
import { GlobalState } from '@/redux/rootReducer';
import { Helmet } from 'react-helmet-async';
import isEqual from 'react-fast-compare';
import { saveFullStorySessionData } from '@/redux/modules/analytics';

const DELAY_SECONDS = 120;

type OwnProps = {};

const mapStateToProps = (state: GlobalState) => {
    const ANMS = getANMS(state);
    const bidderEmail = getBidderEmail(state);
    const bidderId = getBidderId(state);
    const creditCardValidated = getIsBidderCardValid(state);
    const profileComplete = isProfileComplete(state);
    const useFullstory = getUseFullstory(state);
    const userFullName = getUserFullName(state);

    return {
        ANMS,
        bidderEmail,
        bidderId,
        creditCardValidated,
        profileComplete,
        useFullstory,
        userFullName,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveFullStorySessionData,
        },
        dispatch
    );

type ReduxProps = {
    ANMS: number;
    bidderEmail: string;
    bidderId: number;
    creditCardValidated: boolean;
    profileComplete: boolean;
    useFullstory: boolean;
    userFullName: string;
};

type ReduxActions = {
    saveFullStorySessionData: Function;
};

type Props = OwnProps & ReduxProps & ReduxActions;

type State = {
    addScriptToDOM: boolean;
};

class FullStory extends Component<Props, State> {
    state = {
        addScriptToDOM: false,
    };

    componentDidMount() {
        if (this.props.useFullstory) {
            this.addTimeout = setTimeout(() => {
                this.setState({ addScriptToDOM: true });
            }, DELAY_SECONDS * 1000);
            window['_fs_ready'] = this.handleFSReady;
        }
    }

    shouldComponentUpdate = (nextProps, nextState) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentWillUnmount() {
        if (this.addTimeout) {
            clearTimeout(this.addTimeout);
        }
    }

    addTimeout: any;

    handleFSReady = () => {
        this.identify();
        this.tryToSaveSessionUrl();
    };

    identify = () => {
        const { ANMS, bidderEmail, bidderId, creditCardValidated, profileComplete, userFullName } = this.props;

        // @ts-ignore
        if (bidderId && bidderId !== -1 && window.FS && window.FS.identify) {
            // @ts-ignore
            window.FS.identify(`${bidderId}`, {
                ANMS_real: ANMS,
                creditCardValidated_bool: creditCardValidated,
                displayName: userFullName,
                email: bidderEmail,
                profileComplete_bool: profileComplete,
            });
        }
    };

    tryToSaveSessionUrl = () => {
        let sessionUrl = '';
        let sessionID = '';
        // @ts-ignore
        if (window.FS && window.FS.getCurrentSessionURL) {
            // @ts-ignore
            sessionUrl = window.FS.getCurrentSessionURL();
            // @ts-ignore
            sessionID = window.FS.getCurrentSession();
            if (sessionUrl) {
                this.props.saveFullStorySessionData({ sessionID, sessionUrl });
            }
        }
    };

    render() {
        return this.state.addScriptToDOM ? (
            <Helmet>
                <script type="text/javascript">
                    {`
                    window['_fs_debug'] = false;
                    window['_fs_host'] = 'fullstory.com';
                    window['_fs_org'] = '1MKRH';
                    window['_fs_namespace'] = 'FS';
                    (function(m,n,e,t,l,o,g,y){
                        if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
                        g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
                        o=n.createElement(t);o.async=1;o.src='https://'+_fs_host+'/s/fs.js';
                        y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
                        g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
                        g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
                        g.consent=function(a){g("consent",!arguments.length||a)};
                        g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
                        g.clearUserCookie=function(){};
                        g.getCurrentSessionURL=function(){return '';};
                    })(window,document,window['_fs_namespace'],'script','user');`}
                </script>
            </Helmet>
        ) : null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FullStory);
